import React, { Fragment } from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { Work, WorkClaim } from './types';
import trackClick from 'js/utils/trackClick';

type WorkMetadataProps = {
  sourceClaim: WorkClaim;
  work: Work;
  metadataLocation: string;
  showTitle?: boolean;
};

const SecondaryText = styled(Body)`
  color: var(--text-secondary, #535366);
`;

const WorkMetadata: React.FunctionComponent<WorkMetadataProps> = ({
  sourceClaim,
  work,
  metadataLocation,
  showTitle = true,
}) => {
  return (
    <>
      {showTitle && (
        <BodyLink
          size="sm"
          href={work.url}
          onClick={() => {
            trackClick({
              source: 'single_claim_page.work_metadata.see_full_paper',
              extra: {
                source_claim_id: sourceClaim.id,
                metadata_location: metadataLocation,
              },
            });
          }}
        >
          {work.title}
        </BodyLink>
      )}
      {work.authors && (
        <SecondaryText size="sm">
          {work.authors.map((author, index) => (
            <Fragment key={`${author.name}-${index}`}>
              {index > 0 ? ', ' : null}
              <BodyLink
                size="sm"
                href={author.url}
                onClick={() => {
                  trackClick({
                    source: 'single_claim_page.work_metadata.author.click',
                    extra: {
                      author_id: author.id,
                      source_claim_id: sourceClaim.id,
                      metadata_location: metadataLocation,
                    },
                  });
                }}
              >
                {author.name}
              </BodyLink>
            </Fragment>
          ))}
        </SecondaryText>
      )}
      {work.publication && (
        <SecondaryText size="sm">
          {work.publication}
          {work.publication_year ? `, ${work.publication_year}` : ''}
        </SecondaryText>
      )}
    </>
  );
};

export default WorkMetadata;
